import users from './users';
import settings from './settings';
import customers from './customers';
import products from './products';
import billing from './billing';
import subscriptions from './subscriptions';
import instruments_sales from './instruments_sales';
import achievements from './achievements';

export default [
    {
        path: '/admin',
        component: require('@/components/EmptyRouterView').default,
        meta: {
            auth: true
        },
        children: [
            {
                path: '/',
                redirect: to => {
                    return {
                        name: 'admin.users.index'
                    }
                }
            },

            {
                path: 'dashboard',
                name: 'admin.dashboard',
                component: () => import('@/views/dashboard/show'),
                meta: {
                    admin: true,
                    auth: {
                        roles: ['access-admin-dashboard']
                    }
                }
            },

            ...subscriptions,
            ...users,
            ...settings,
            ...customers,
            ...products,
            ...billing,
            ...instruments_sales,
            ...achievements
        ]
    }
]
